import { string, func, object, bool } from 'prop-types'
import Alert from '@ui/elements/Alert'

const InputType = ({
  name,
  cssClass,
  value,
  placeholder,
  error,
  onChange = () => { },
  type = 'text',
  otherProps = {},
  isRequired = false
}) => {
  return (
    <>
      <input
        className={cssClass}
        type={type}
        placeholder={placeholder}
        name={name}
        onChange={onChange}
        value={value}
        {...otherProps}
        required={isRequired}
      />
      {error && <Alert cssClass='clear' type='is-danger' message={error} />}
    </>
  )
}

InputType.propTypes = {
  name: string,
  onChange: func,
  otherProps: object,
  cssClass: string,
  type: string,
  value: string,
  placeholder: string,
  error: string,
  isRequired: bool
}

export default InputType
